import { useGetTenantSettingsQuery } from '@/store/api';
/**
 * Hook to access tenant settings from RTK Query cache.
 *
 * @returns The tenant settings data, or undefined if not yet loaded
 */
export const useTenantSettings = () => {
    const { data } = useGetTenantSettingsQuery();
    return data;
};
